import { Injectable, inject } from '@angular/core';
import { ModalController } from '@ionic/angular/standalone';

import { ProfileService } from '../../app/pages/profile/profile.service';
import { Profile } from '../../app/pages/profile/profile.model';
import { ProfileErrorModal } from '../../app/components/profile-error/profile-error.modal';
import { InterestsOnboardingModal } from '../../app/components/interests-onboarding/interests-onboarding.modal';

@Injectable({ providedIn: 'root' })
export class StartupOrchestratorService {

  private readonly profileService = inject(ProfileService);
  private readonly modalCtrl = inject(ModalController);

  private inFlight: Promise<void> | null = null;

  runPostAuthChecks(): Promise<void> {
    if (this.inFlight) return this.inFlight;
    this.inFlight = this.doRunPostAuthChecks().finally(() => {
      this.inFlight = null;
    });
    return this.inFlight;
  }

  private async doRunPostAuthChecks(): Promise<void> {
    const profile = await this.ensureProfileLoaded();
    if (profile.interessiSpecificati !== true) {
      await this.openInterestsModal();
    }
  }

  private async ensureProfileLoaded(): Promise<Profile> {
    const cached = this.profileService.currentProfile;
    if (cached) return cached;

    try {
      return await this.profileService.loadProfile();
    } catch {
      return this.openProfileErrorModalWithRetry();
    }
  }

  private async openProfileErrorModalWithRetry(): Promise<Profile> {
    const modal = await this.modalCtrl.create({
      component: ProfileErrorModal,
      canDismiss: false,
      backdropDismiss: false,
      showBackdrop: true,
      cssClass: 'profile-error-modal',
    });
    await modal.present();
    const { data } = await modal.onDidDismiss<Profile>();
    // canDismiss=false garantisce che data sia valorizzato solo tramite retry riuscito
    return data!;
  }

  private async openInterestsModal(): Promise<void> {
    const modal = await this.modalCtrl.create({
      component: InterestsOnboardingModal,
      canDismiss: true,
      backdropDismiss: false,
      showBackdrop: false,
      cssClass: 'interests-onboarding-modal',
    });
    await modal.present();
    await modal.onDidDismiss();
  }
}
